import { render } from "./EditCompanyAddress.vue?vue&type=template&id=0e0a23d5"
import script from "./EditCompanyAddress.vue?vue&type=script&lang=js"
export * from "./EditCompanyAddress.vue?vue&type=script&lang=js"

import "./EditCompanyAddress.vue?vue&type=style&index=0&id=0e0a23d5&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__